import { writable, get } from "svelte/store";
import * as api from "../../utiles/api.js";
import toast from "svelte-french-toast";

const today = new Date();
const fourMonthsLater = new Date();
today.setMonth(today.getMonth() - 4);
fourMonthsLater.setMonth(today.getMonth() + 8);

const formatDate = (date) => date.toISOString().split('T')[0];

export const processInspectionStore = writable({
    list: [],
    selectedItem: null,
    search: {
        prdctn_plan_no: "",
        lot_no: "",
        search_korean_nm: "",
        startDate: '2025-01-01',
        endDate: '2026-12-31',
        prpert_at: "전체",
        isExpanded: true,
    },
    scrollPos: 0,
});

export const inspectionWaitingStore = writable({
    list: [],
    search: {
        plan_no: "",
        mnfctur_order_no: "",
        item_code: "",
        item_nm: "",
        startDate: '2025-01-01',
        endDate: '2026-12-31',
        inspct_at: "전체",
        lot_no: "",
    },
    modalOpen: false
});

export const appStateStore = writable({
    currentView: "list", // 'list', 'detail'
    selectedId: null,
    waitingData: null,
});

export async function fetchProcessInspectionData(bplc_code, silent = false) {
    const store = get(processInspectionStore);
    try {
        const params = new URLSearchParams({
            bplc_code: bplc_code || "01",
            startDate: store.search.startDate || "",
            endDate: store.search.endDate || "",
            prdctn_plan_no: store.search.prdctn_plan_no || "",
            lot_no: store.search.lot_no || "",
            search_korean_nm: store.search.search_korean_nm || "",
            prpert_at: store.search.prpert_at === "전체" ? "" : store.search.prpert_at,
        });

        const response = await api.get(`process-inspection/list?${params.toString()}`);

        if (response && response.data) {
            processInspectionStore.update((s) => ({
                ...s,
                list: response.data,
            }));
            if (!silent) toast.success("공정검사 조회 완료");
        }
    } catch (err) {
        console.error(err);
        if (!silent) toast.error("공정검사 조회 중 오류가 발생했습니다.");
    }
}

export async function fetchProcessInspectionWaitingData(bplc_code, silent = false) {
    const store = get(inspectionWaitingStore);
    const loadingToast = silent ? null : toast.loading("검사대기정보 조회 중...");
    try {
        const params = new URLSearchParams({
            bplc_code: bplc_code || "01",
            plan_no: store.search.plan_no || "",
            mnfctur_order_no: store.search.mnfctur_order_no || "",
            item_code: store.search.item_code || "",
            item_nm: store.search.item_nm || "",
            startDate: store.search.startDate || "",
            endDate: store.search.endDate || "",
            inspct_at: store.search.inspct_at === "전체" ? "" : store.search.inspct_at,
            lot_no: store.search.lot_no || "",
        });

        const response = await api.get(`process-inspection/waiting/list?${params.toString()}`);

        if (response && response.data) {
            inspectionWaitingStore.update((s) => ({
                ...s,
                list: response.data,
            }));
            if (!silent) {
                toast.dismiss(loadingToast);
                toast.success(`총 ${response.data.length}건 조회되었습니다.`);
            }
        } else if (!silent) {
            toast.dismiss(loadingToast);
        }
    } catch (err) {
        console.error(err);
        if (!silent) {
            toast.dismiss(loadingToast);
            toast.error("조회 중 오류가 발생했습니다.");
        }
    }
}

export const inspectionClassStore = writable({
    list: [],
    selectedCode: "",
});

export async function fetchClassifications(bplc_code) {
    try {
        const response = await api.get(`process-inspection/classification/list?bplc_code=${bplc_code}`);
        if (response && response.data) {
            inspectionClassStore.update((s) => ({
                ...s,
                list: response.data,
            }));
        }
    } catch (err) {
        console.error("Failed to fetch classifications:", err);
    }
}
